import React from 'react'
import classNames from 'classnames'

import { WiredCardElement } from 'marketing-site/src/library/elements/WiredCardElement'
import { useMediaQuery, mq } from '../../utils'
import { IProps } from './index'

export const WiredCardsComponent = ({ cards }: IProps): React.ReactElement => {
  const isMobile = useMediaQuery(`(${mq.mobile})`)

  const classes = classNames('wired-cards', {
    'wired-cards--scroll': isMobile,
  })
  const containerClasses = classNames('wired-cards__container', {
    'wired-cards__container--animate': !isMobile,
  })

  return (
    <div className={classes} data-testid="wired-cards">
      <div className={containerClasses}>
        {cards.map((card) => (
          <div className="wired-cards__items" key={card.description}>
            <WiredCardElement {...card} />
          </div>
        ))}
      </div>
      {!isMobile && (
        <div className="wired-cards__container wired-cards__container--animate">
          {cards.map((card) => (
            <div className="wired-cards__items" key={card.description}>
              <WiredCardElement {...card} />
            </div>
          ))}
        </div>
      )}

      <style jsx>
        {`
          .wired-cards {
            width: 100%;
            display: flex;
            flex-flow: row nowrap;
            position: relative;
            overflow: hidden;
            scrollbar-width: none;

            &:hover {
              .wired-cards__container--animate {
                animation-play-state: paused;
              }
            }

            &__container {
              padding: 2rem 0;
              display: flex;
              flex-flow: row nowrap;
              width: min-content;
              position: relative;

              &--animate {
                animation-duration: ${cards.length * 15}s;
                animation-iteration-count: infinite;
                animation-timing-function: linear;
                animation-name: scrolling;
              }
            }

            &__items {
              margin-right: 2rem;

              &:first-child {
                margin-left: 2rem;
              }

              &:last-child {
                margin-right: 0;
              }
            }
          }

          @keyframes scrolling {
            0% {
              transform: translateX(0);
            }
            100% {
              transform: translateX(-100%);
            }
          }

          @media (${mq.mobile}) {
            .wired-cards {
              &:hover {
                .wired-cards__container--animate {
                  animation-play-state: running;
                }
              }

              &--scroll {
                z-index: 1;
                animation: none;
                overflow: scroll hidden;
                -ms-overflow-style: none;
                scrollbar-width: none;

                &::-webkit-scrollbar {
                  width: 0 !important;
                }
              }
            }
          }

          @media (${mq.desktop}) {
            .wired-cards {
              &__items {
                margin-right: 3.125rem;

                &:first-child {
                  margin-left: 3.125rem;
                }

                &:last-child {
                  margin-right: 0;
                }
              }
            }
          }

          @media (${mq.desktopXLg}) {
            .wired-cards {
              max-width: $viewport-max-width;
              margin: auto;
              mask-image: linear-gradient(
                to right,
                rgba(255, 255, 255, 0) calc(0% + 2rem),
                white calc(0% + 6.25rem),
                white calc(100% - 6.25rem),
                rgba(255, 255, 255, 0) calc(100% - 2rem)
              );
            }
          }
        `}
      </style>
    </div>
  )
}
